import { LegalLayout, CLINIC } from "../components/LegalLayout";

export default function LegalNotice() {
  return (
    <LegalLayout title="Aviso Legal">
      <h2>1. Información del prestador del servicio</h2>
      <p>En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información
      y de Comercio Electrónico (LSSICE):</p>
      <ul>
        <li><strong>Titular:</strong> Dr. Dimy Laguerre</li>
        <li><strong>NIF:</strong> {CLINIC.nif}</li>
        <li><strong>Profesión:</strong> Médico Especialista en Medicina de Urgencias y Emergencias, colegiado</li>
        <li><strong>Nº Colegiado:</strong> {CLINIC.colegiado}</li>
        <li><strong>Domicilio profesional:</strong> {CLINIC.address}</li>
        <li><strong>Email de contacto:</strong> {CLINIC.email}</li>
        <li><strong>Teléfono:</strong> {CLINIC.phone}</li>
        <li><strong>Dominio web:</strong> {CLINIC.domain}</li>
        <li><strong>Actividad profesional regulada:</strong> Medicina, conforme a la Ley 44/2003 de
        ordenación de las profesiones sanitarias.</li>
        <li><strong>Colegio profesional:</strong> Ilustre Colegio Oficial de Médicos de Sevilla.</li>
      </ul>

      <h2>2. Objeto</h2>
      <p>El presente aviso legal regula el uso del sitio web {CLINIC.domain} (en adelante, "el sitio") y
      los servicios de telemedicina ofrecidos a través del mismo, que incluyen reserva de citas, consulta
      videoconferencia, expedición de recetas electrónicas, peticiones de pruebas diagnósticas y chat médico.</p>

      <h2>3. Condiciones de uso</h2>
      <p>El acceso a este sitio es libre y gratuito. Determinados servicios (consulta médica, recetas)
      están sujetos al pago de una tarifa que será informada al usuario antes de la formalización de la cita.</p>
      <p>El usuario se compromete a hacer uso del sitio conforme a la legalidad vigente, la buena fe y el
      respeto a los derechos de terceros.</p>

      <h2>4. Propiedad intelectual e industrial</h2>
      <p>Todos los contenidos del sitio (textos, imágenes, logotipos, código, diseño) son propiedad del
      titular o cuentan con licencia para su uso. Queda prohibida su reproducción total o parcial sin
      autorización expresa.</p>

      <h2>5. Responsabilidad</h2>
      <p>El titular no garantiza la ausencia de interrupciones o errores en el acceso al sitio, si bien se
      compromete a adoptar medidas razonables para evitarlos. No se asume responsabilidad por los daños
      derivados del uso del sitio cuando éste sea contrario a las condiciones aquí establecidas.</p>
      <p>El contenido informativo del sitio <strong>no sustituye en ningún caso</strong> la consulta médica
      presencial cuando ésta sea necesaria conforme al criterio profesional.</p>

      <h2>6. Enlaces externos</h2>
      <p>El sitio puede contener enlaces a sitios de terceros (Stripe, Wise, Jitsi, Resend) cuyo contenido y
      políticas son responsabilidad de sus respectivos titulares.</p>

      <h2>7. Legislación aplicable y jurisdicción</h2>
      <p>El presente aviso se rige por la legislación española. Para la resolución de controversias, las
      partes se someten a los Juzgados y Tribunales de Sevilla, sin perjuicio de los derechos del consumidor
      reconocidos por la normativa vigente.</p>
    </LegalLayout>
  );
}
